import React from "react";
import S from './AdditionalInformation.module.scss';

export const MonitorElectric = () => {
    return (
        <div className={S.monitorElectricStyle}>
            <p>
                Более 25 лет нашими продуктами пользуются крупные предприятия промышленного и нефтегазового
                секторов, системные операторы электроэнергетических систем, генерирующие и электросетевые
                компании, а также операторы автономных энергосистем (microgrid) в России, Белоруссии, Казахстане,
                Грузии и Азербайджане.
            </p>
            <p>На стенде мы представим нашу <span>инновационную разработку — СК.ПУЭР.</span></p>
            <p>
                <span>СК.ПУЭР</span> — платформа для автоматизации технического учета энергоресурсов на объектах
                энергетики и
                промышленных предприятиях, объединяющая возможности учета различных видов энергоресурсов со
                скоростным сбором данных от приборов учета, повышающим наблюдаемость нетелемеханизированных
                участков электрических сетей, действуя как система верхнего уровня (HES).
            </p>
            <p>
                CK.ПУЭР обеспечивает:
                <li>Поддержку учета электроэнергии, газа, воды, пара и других энергоресурсов;</li>
                <li>Наблюдаемость нетелемеханизированных участков электрических сетей, в том числе сетей 0,4 кВ;
                </li>
                <li>Автоматический расчет балансов электроэнергии с оповещением о выходе за границы согласно
                    техпроцессам ;
                </li>
                <li>Ведение плана потребления в энергосистеме с часовой детализацией и данными по плану
                    генерации;
                </li>
                <li>Анализ нерационального использования и потерь электроэнергии.</li>
            </p>
            <p>
                Также мы проведем <span>живые демонстрации</span> других наших продуктов, доказавших свою
                эффективность на сотнях площадок внедрений:
                <li><span>СК-11</span> — ключевое решение Монитор Электрик в области оперативно-технологического
                    управления объектами электроэнергетики, включающее в себя высокопроизводительную SCADA,
                    расчетно-аналитические приложения, средства управления переключениями, тренажеры и другие
                    компоненты.</li>
                <li><span>СК.Заявки</span> — система управления заявками на изменение технологического режима
                    работы или эксплуатационного состояния линий электропередачи, основного и вспомогательного
                    оборудования объектов электроэнергетики и устройств РЗА, обеспечивающая комплексную
                    автоматизацию работ с заявками и графиками ремонтов на всех уровнях оперативно-технологического
                    управления.
                </li>
                <li><span>СК.Журналы</span> — комплекс кросс-платформенных приложений для ведения и хранения
                    технологической документации при оперативной работе, обслуживании и ремонте электроустановок и
                    другого оборудования, позволяющий в сжатые сроки перевести ведение технологической документации
                    в цифровой вид.
                </li>
            </p>
            <p>
                Все решения полностью соответствуют требованиям Правительства РФ по вопросам импортозамещения и
                включены в единый реестр российских программ для ЭВМ и баз данных.
            </p>
            <p>
                <span>Экосистема продуктов компании Монитор Электрик</span> — надежная цифровая основа для создания
                современных
                центров управления электроснабжением промышленных предприятий.
            </p>
        </div>
    );
};
